/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FareBasisIndexValidationData
 */
export interface FareBasisIndexValidationData {
    /**
     * 
     * @type {number}
     * @memberof FareBasisIndexValidationData
     */
    index?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FareBasisIndexValidationData
     */
    fareBasisError?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FareBasisIndexValidationData
     */
    ticketDesignatorError?: boolean;
}

export function FareBasisIndexValidationDataFromJSON(json: any): FareBasisIndexValidationData {
    return FareBasisIndexValidationDataFromJSONTyped(json, false);
}

export function FareBasisIndexValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareBasisIndexValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'index': !exists(json, 'index') ? undefined : json['index'],
        'fareBasisError': !exists(json, 'fareBasisError') ? undefined : json['fareBasisError'],
        'ticketDesignatorError': !exists(json, 'ticketDesignatorError') ? undefined : json['ticketDesignatorError'],
    };
}

export function FareBasisIndexValidationDataToJSON(value?: FareBasisIndexValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'index': value.index,
        'fareBasisError': value.fareBasisError,
        'ticketDesignatorError': value.ticketDesignatorError,
    };
}


